<template>
  <div>
    <pulse-loader :loading="loading"></pulse-loader>
    <e-charts
      v-if="!loading"
      autoresize
      :options="line"
      theme="ovilia-green"
      ref="line"
      auto-resize
    />
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/dataZoom";
import "echarts/lib/chart/bar";
import theme from "../graph/theme.json";
import axios from "../../axios";
import moment from "moment";
import { mapState } from "vuex";

ECharts.registerTheme("ovilia-green", theme);

export default {
  computed: mapState(["customerStatus"]),
  props: ["connectionId"],
  methods: {
    async GetConnectionInfo() {
      let response = await axios().get(`/api/connections/${this.connectionId}`);
      this.connection = response.data;
    },
    async GetData() {
      if (this.loading) {
        return;
      }

      if (!this.customerStatus.has_smart_meter_points) {
        return;
      }
      if (
        this.$store.state.usageSettings.fromDate == null ||
        this.$store.state.usageSettings.toDate == null
      ) {
        return;
      }

      if (this.$store.state.usageSettings.unity == "Usage") {
        this.line.yAxis.name = `In ${this.$t(
          `Productunity.${this.connection.type}`
        )}`;
      } else {
        this.line.yAxis.name = `In Euro's`;
      }
      this.loading = true;
      try {
        this.line.series = [];
        let trigger = this.$store.state.usageSettings.triggerNewData.trigger;
        trigger =
          trigger != null
            ? `&trigger=${this.$store.state.usageSettings.triggerNewData.trigger}`
            : null;
        let response = await axios().get(
          `/api/EnergyConsumption?connectionId=${this.connectionId}&startDate=${
            this.$store.state.usageSettings.fromDate
          }&endDate=${this.$store.state.usageSettings.toDate}&typeUnity=${
            this.$store.state.usageSettings.unity
          }&intervalConsumption=${this.$store.state.usageSettings.interval}${
            trigger == null ? "" : trigger
          }`
        );

        this.$store.commit("updateFromDate", response.headers["x-startdate"]);
        this.$store.commit("updateToDate", response.headers["x-enddate"]);

        this.loading = false;
        response.data.forEach(element => {
          let template = {
            type: "bar",
            showSymbol: false,
            hoverAnimation: false,
            smooth: true
          };
          template.name = element.label;
          template.data = element.data.map(function(item) {
            return [
              new Date(item.date),
              item.value,
              element.label,
              item.tariff,
              item.usage
            ];
          });
          this.line.series.push(template);
        });
      } catch (error) {
        this.loading = false;
      }
    },
    toTable(individual_prices) {
      let result = "";
      Object.keys(individual_prices).forEach(function(key) {
        result += `<br>${key}:  <i>&euro;${(
          Math.round(individual_prices[key] * 100000) / 100000
        ).toFixed(5)} </i>`;
      });

      return result;
    }
  },
  async mounted() {
    await this.GetConnectionInfo();
    await this.GetData();
    this.$store.watch(
      state => state.usageSettings.triggerNewData,
      this.GetData
    );
  },
  data() {
    return {
      connection: {},
      loading: false,
      line: {
        // Make gradient line here

        legend: {
          x: "left"
        },
        tooltip: {
          trigger: "axis",
          formatter: params => {
            let date = moment(params[0].data[0]).locale("nl");
            let values = "";
            params.forEach(param => {
              let value = "";
              if (this.$store.state.usageSettings.unity == "Usage") {
                value = `<br>
                <b>
             ${param.value[2]}: ${Math.round(param.value[1] * 1000) / 1000}
             ${this.$t(`Productunity.${this.connection.type}`)}</b>`;
              } else {
                value = `

                <br>

 <b>
              ${param.value[2]}:  &euro;${(
                  Math.round(param.value[1] * 1000) / 1000
                ).toFixed(3)} (${Math.round(param.value[4] * 1000) /
                  1000} ${this.$t(`Productunity.${this.connection.type}`)})</b>
                 `;
              }
              values += value;
            });
            if (this.$store.state.usageSettings.unity == "Money") {
              values += `
             <small>
                  <br>
                  <br>
                 Prijzen per ${this.$t(`Productunity.${this.connection.type}`)}:
                   ${this.toTable(
                     params[0].value[3].individual_prices_incl_vat
                   )}
                </small>
                `;
            }
            values = values.split(".").join(",");

            return `${date.format("LLLL")} ${values}`;
          }
        },
        dataZoom: [
          {
            type: "inside",
            show: true
          }
        ],
        xAxis: {
          type: "time",
          splitLine: {
            show: true
          },
          axisLabel: {
            formatter: function(value) {
              let date = moment(value);
              return date.hour() == 0 && date.minute() == 0
                ? date.format("DD-MM-YY")
                : date.format("HH:mm");
            }
          }
        },

        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}"
          },
          name: "",
          nameLocation: "middle",
          nameGap: 0,
          splitLine: { show: true }
        },
        series: []
      }
    };
  },
  components: {
    ECharts,
    PulseLoader
  }
};
</script>
